import { createRootRoute, Outlet } from '@tanstack/react-router'

import { Identifier } from '@/components/identifier.tsx'
import { Providers } from '@/components/providers.tsx'

export const Route = createRootRoute({
  component: Root,
})

export function Root() {
  return (
    <Providers>
      <Outlet />

      <Identifier />
    </Providers>
  )
}
